import {saveAs} from 'file-saver'
import ExcelJS from 'exceljs'
import {useEffect, useState} from 'react'
import Importcsv from '../Importcsv'
import {Addvendors} from '../Addvendors'
import {useAuth} from '../../../../modules/auth'
import {collection, doc, onSnapshot, Timestamp} from 'firebase/firestore'
import db from '../../../../../services/firebase'
import {showErrorToast, showSuccessToast} from 'app/components/ShowToast'
import ExportButton from 'app/components/ExportButton'
import Button from 'app/components/Button'
import {format} from 'date-fns'

const VendorListToolbar = ({currentAuditContext}) => {
  const {currentUser} = useAuth()
  const [isDropdownVisible, setDropdownVisible] = useState(false)
  const [isCSV, setIsCSV] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [vendor, setVendor] = useState<any[]>([])

  useEffect(() => {
    getVendor()
  }, [])

  const getVendor = async () => {
    try {
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)
      const PolicyRef = collection(tenantRef, 'vendors')

      const unsubscribe = onSnapshot(PolicyRef, (snapshot) => {
        const risksData = snapshot.docs
          .map((doc) => ({
            ...doc.data(),
            id: doc.id,
            archived: doc.data().archived,
          }))
          .filter((vendor) => !vendor.archived) 
        setVendor(risksData)
      })

      return unsubscribe
    } catch (error) {
      console.error('Error getting controls:', error)
    }
  }

  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible)
  }
  const handleMannually = () => {
    setIsCSV(!isCSV)
  }

  const handleOpenModal2 = () => {
    setIsCSV(true)
  }

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }
  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const exportData = async () => {
    if (vendor.length > 0) {
      const workbook = new ExcelJS.Workbook()
      const worksheet = workbook.addWorksheet('Vendor Risks')

      worksheet.columns = [
        {header: 'Vendor Name', key: 'vendor_name', width: 30},
        {header: 'Category', key: 'category', width: 20},
        {header: 'Website URL', key: 'website_url', width: 30},
        {header: 'Policy URL', key: 'policy_url', width: 30},
        {header: 'Terms URL', key: 'terms_url', width: 30},
        {header: 'Reliance', key: 'reliance', width: 15},
        {header: 'Risk Level', key: 'risk_level', width: 15},
        {header: 'Authentication Type', key: 'authentication_type', width: 20},
        {header: 'Diligence File Name', key: 'diligence_file_name', width: 30},
        {header: 'Diligence File', key: 'diligence_file', width: 50},
        {header: 'Due Diligence Status', key: 'due_diligence_status', width: 20},
        {header: 'Due Diligence Date', key: 'due_diligence_date', width: 20},
        {header: 'Skip Next Due Diligence', key: 'skip_next_due_diligence', width: 25},
        {header: 'Two Factor Authentication', key: 'two_factor', width: 25},
        {header: 'Impact Assessment', key: 'impact_assessment', width: 50},
        {header: 'Owner', key: 'owner', width: 20},
        {header: 'Created At', key: 'created_at', width: 20},
        {header: 'Updated At', key: 'updated_at', width: 20},
      ]

      const headerRow = worksheet.getRow(1)
      headerRow.font = {bold: true, color: {argb: 'FFFFFFFF'}, size: 10}
      headerRow.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {argb: 'FF000000'},
      }
      headerRow.height = 30
      headerRow.alignment = {horizontal: 'center', vertical: 'middle'}
      worksheet.views = [{state: 'frozen', ySplit: 1}]

      worksheet.getCell('J1').note = {
        texts: [{text: 'Click on file links to download directly.'}],
        margins: {insetmode: 'auto'},
      }

      const exportData = vendor.map((row) => ({
        vendor_name: row.vendor_name || '',
        category: row.category || '',
        website_url: row.website_url || '',
        policy_url: row.policy_url || '',
        terms_url: row.terms_url || '',
        reliance: row.reliance || '',
        risk_level: row.risk_level || '',
        authentication_type: row.authentication_type || '',
        diligence_file_name: row.diligence?.[0]?.diligence_file_name || '',
        diligence_file: '',
        due_diligence_status: row.due_diligence_status || '',
        due_diligence_date: row.due_diligence_date || '',
        skip_next_due_diligence: row.skip_next_due_diligence ? 'Yes' : 'No',
        two_factor: row.two_factor ? 'Yes' : 'No',
        impact_assessment: row.impact_assessment?.join(', ') || '',
        owner: row.owner || '',
        created_at: row?.created_at
          ? row.created_at instanceof Timestamp
            ? format(row.created_at.toDate(), 'yyyy-MM-dd')
            : format(row.created_at, 'yyyy-MM-dd')
          : '',
        updated_at: row?.updated_at
          ? row.updated_at instanceof Timestamp
            ? format(row.updated_at.toDate(), 'yyyy-MM-dd')
            : format(row.updated_at, 'yyyy-MM-dd')
          : '',
      }))

      exportData.forEach((item, index) => {
        const row = worksheet.addRow(item)
        row.height = 20
        row.font = {size: 10}

        const diligenceFileCell = row.getCell('J')
        const vendorData = vendor[index]
        if (vendorData.diligence && Array.isArray(vendorData.diligence) && vendorData.diligence.length > 0) {
          const diligenceFile = vendorData.diligence[0]
          if (diligenceFile.diligence_url && diligenceFile.diligence_file_name) {
            let downloadUrl = diligenceFile.diligence_url

            if (downloadUrl.includes('firebasestorage.googleapis.com')) {
              downloadUrl = `${downloadUrl}&response-content-disposition=attachment;filename=${encodeURIComponent(
                diligenceFile.diligence_file_name
              )}`
            }

            const escapedName = diligenceFile.diligence_file_name.replace(/"/g, '""')
            const escapedUrl = downloadUrl.replace(/"/g, '""')

            diligenceFileCell.value = {formula: `HYPERLINK("${escapedUrl}", "${escapedName}")`}
            diligenceFileCell.alignment = {wrapText: true, vertical: 'middle'}
          }
        }

        if (item.reliance === 'High') {
          row.getCell('F').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: 'F4CCCC'},
          }
        } else if (item.reliance === 'Medium') {
          row.getCell('F').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: 'FFF2CC'},
          }
        } else if (item.reliance === 'Low') {
          row.getCell('F').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: 'D9EAD3'},
          }
        }

        if (item.risk_level === 'High') {
          row.getCell('G').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: 'F4CCCC'},
          }
        } else if (item.risk_level === 'Medium') {
          row.getCell('G').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: 'FFF2CC'},
          }
        } else if (item.risk_level === 'Low') {
          row.getCell('G').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: 'D9EAD3'},
          }
        }

        if (item.due_diligence_status === 'Incomplete') {
          row.getCell('K').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: 'F4CCCC'},
          }
        } else if (item.due_diligence_status === 'Complete') {
          row.getCell('K').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: 'D9EAD3'},
          }
        }
      })

      const buffer = await workbook.xlsx.writeBuffer()
      const excelBlob = new Blob([buffer], {type: 'application/octet-stream'})
      saveAs(excelBlob, `VendorRisks.xlsx`)
      showSuccessToast({message: 'Vendor risks data exported successfully'})
    }else {
      if (typeof showSuccessToast === 'function') {
        showErrorToast({message: 'No data to export'})
      }
      return
    }
  }

  return (
    <>
      <Addvendors isOpen={isModalOpen} onClose={handleCloseModal} />
      <Importcsv isOpen={isCSV} onClose={handleMannually} />
      {currentUser?.role !== 'Auditor' && !currentAuditContext && (
      <ExportButton className='me-4' onClick={exportData} />
      )}
      <div className='dropdown'>
        {currentUser?.role !== 'Auditor' && !currentAuditContext && (
          <Button
            btnType='primary'
            onClick={toggleDropdown}
            id='dropdownMenu2'
            data-bs-toggle='dropdown'
            aria-haspopup='true'
            aria-expanded='false'
          >
            <span className='mx-2'>Add Vendor</span>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              stroke-width='2'
              stroke-linecap='round'
              stroke-linejoin='round'
              className='icon icon-tabler icons-tabler-outline icon-tabler-chevron-down rotate-180'
            >
              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
              <path d='M6 9l6 6l6 -6' />
            </svg>
          </Button>
        )}
        <ul className='dropdown-menu mt-2' aria-labelledby='dropdownMenu2' style={{width: '150px'}}>
          <li>
            <button
              className='dropdown-item text-hover-primary button-with-icon'
              type='button'
              onClick={handleOpenModal}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='18'
                height='18'
                viewBox='0 0 24 24'
                fill='none'
                stroke='#5A5A5A'
                stroke-width='2'
                stroke-linecap='round'
                stroke-linejoin='round'
                className='icon icon-tabler icons-tabler-outline icon-tabler-pencil mb-1 mx-1 '
              >
                <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                <path d='M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4' />
                <path d='M13.5 6.5l4 4' />
              </svg>{' '}
              Add manually
            </button>
          </li>

          <li>
            <button
              className='dropdown-item text-hover-primary button-with-icon'
              type='button'
              onClick={handleOpenModal2}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='18'
                height='18'
                viewBox='0 0 24 24'
                fill='none'
                stroke='#5A5A5A'
                stroke-width='2'
                stroke-linecap='round'
                stroke-linejoin='round'
                className='icon icon-tabler icons-tabler-outline icon-tabler-file-import mb-1 mx-1'
              >
                <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                <path d='M14 3v4a1 1 0 0 0 1 1h4' />
                <path d='M5 13v-8a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-5.5m-9.5 -2h7m-3 -3l3 3l-3 3' />
              </svg>{' '}
              Import
            </button>
          </li>
        </ul>
      </div>
    </>
  )
}

export {VendorListToolbar}
